<template>
    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; background: rgb(2,0,36);
background: linear-gradient(0deg, rgba(65,102,177,1) 34%, rgba(69,112,199,1) 100%)" v-loading="loading">
        <el-card class="box-card" style="max-width: 600px; margin: 0 auto; width: 100%; background: #f6f8ff;">
            <div style="font-weight: 700; margin-bottom: 32px;">
                Let's recover your account
            </div>
            <div style="margin-top: 16px;">
                <el-input type="email" placeholder="Email" v-model="email" required></el-input>
            </div>
            <div style="margin-top: 32px; margin-bottom: 32px;">
                <div style="display: flex; align-items: center; flex-direction: row-reverse;">
                    <el-button type="primary" @click.native="handleRecover" style="width: 100%;">Send me recovery link</el-button>
                </div>
            </div>
            <div style="height: 40px; margin: 16px -20px -20px; background: #e1e6f6;">
                <div style="display: flex;align-items: center; justify-content: space-between; padding: 0 20px;">
                    <router-link to="/login">
                        <div style="line-height: 40px; color: #4570c7;">
                            Login
                        </div>
                    </router-link>
                    <router-link to="/signup">
                        <div style="line-height: 40px; color: #4570c7;">
                            Sign up
                        </div>
                    </router-link>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            loading: false,
            email: ''
        }
    },
    methods: {
        handleRecover() {
            this.loading = true;
            axios.post('/recover', {
                    email: this.email
                })
                .then(response => {
                    if (response.data.success) {
                        this.$message({
                            type: 'success',
                            message: 'Recovery email sent!'
                        });
                    } else {
                        this.$message({
                            type: 'danger',
                            message: 'Failed to send recovery email'
                        });
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$message({
                            type: 'danger',
                            message: 'Failed to send recovery email'
                        });
                    this.errorMessage = error.response.data.message
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>